export default {
  statusBtnList: [
    {
      color: 'green',
      text: '回答通過',
    },
    {
      color: 'yellow',
      text: '回答不通過',
    },
    {
      color: 'red',
      text: '尚未回答',
    },
  ],
  remarkKeyList: {
    act_cnt_review_result: 'act_cnt_final_review_remark',
    idtf_check_result: 'idtf_remark',
    idtf_review_result: 'idtf_final_review_remark',
    overall_review_result: 'overall_review_remark',
  }
};